<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For Martha,</p>
<p class="ded1">with, if possible, even more love than before.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2a3bc219